<template>
  <div class="containers">
    <!-- 更改浏览器标题 -->
    <!-- <div class="main" v-title data-title="首页">
    </div> -->
    <!-- 轮播 -->
    <!-- <Swiper></Swiper> -->
    <!-- 平台选择 -->
    <div class="choice">
      <ul>
        <li @click="num = 1">
          <img v-if="num == 1" src="../assets/imgs/集团业务/04.png" alt="" />
          <img v-else src="../assets/imgs/集团业务/01.png" alt="" />
        </li>
        <li @click="num = 2">
          <img v-if="num == 2" src="../assets/imgs/集团业务/05.png" alt="" />
          <img v-else src="../assets/imgs/集团业务/02.png" alt="" />
        </li>
        <li @click="num = 3">
          <img v-if="num == 3" src="../assets/imgs/集团业务/06.png" alt="" />
          <img v-else src="../assets/imgs/集团业务/03.png" alt="" />
        </li>
      </ul>
    </div>
    <div v-show="num == 1">
      <div class="box1 wow slideInUp" data-wow-delay="0.3s">
        <p>{{ $t('business.2-1') }} - {{ $t('business.2-2') }}</p>
        <img src="../assets/imgs/集团业务/船海平台/07.png" alt="" />
      </div>
      <div class="box wow slideInUp" data-wow-delay="0.3s">
        <img src="../assets/imgs/集团业务/船海平台/09.png" alt="" />
        <img src="../assets/imgs/集团业务/船海平台/10.png" alt="" />
        <img src="../assets/imgs/集团业务/船海平台/11.png" alt="" />
      </div>
      <div

        class="cla1 wow slideInUp  oneMain"
        data-wow-delay="0.3s"
      >
        <h4>{{ $t('business.2-1') }} - {{ $t('business.2-3') }}</h4>
        <div>
          <div class="left">
            <img src="../assets/imgs/图片/船海平台/01.png" alt="" />
          </div>
          <div class="right">
            {{ $t('business.2-9') }}
          </div>
        </div>
      </div>
      <div
        class="cla1 wow slideInUp topWidth twoMain"
        data-wow-delay="0.3s"
      >
        <div>
          <div class="left">
            <h4>{{ $t('business.2-1') }} - {{ $t('business.2-4') }}</h4>
            <h5>{{ $t('business.2-10') }}</h5>
            <p>
              {{ $t('business.2-11') }}
            </p>
            <p>
              {{ $t('business.2-12') }}
            </p>
          </div>
          <div class="right">
            <img src="../assets/imgs/图片/船海平台/02.png" alt="" />
          </div>
        </div>
      </div>
      <div
        style="width: 1200px; margin: 40px auto"
        class="cla1 wow slideInUp threeMain"
        data-wow-delay="0.3s"
      >
        <h4>{{ $t('business.2-1') }} - {{ $t('business.2-3') }}</h4>
        <div>
          <div class="left">
            <img src="../assets/imgs/图片/船海平台/03.png" alt="" />
          </div>
          <div class="right">
            <h5>{{ $t('business.2-13') }}</h5>
            <p>
              {{ $t('business.2-14') }}
            </p>
            <h5>{{ $t('business.2-15') }}</h5>
            <p>
              {{ $t('business.2-16') }}
            </p>
          </div>
        </div>
      </div>
      <div
        style="width: 1200px; margin: 40px auto"
        class="cla1 wow slideInUp fourMian"
        data-wow-delay="0.3s"
      >
        <div>
          <div class="left">
            <h4>{{ $t('business.2-1') }} - {{ $t('business.2-5') }}</h4>
            <p>
              {{ $t('business.2-17') }}
            </p>
            <p>
              {{ $t('business.2-18') }}
            </p>
            <p>{{ $t('business.2-19') }}</p>
          </div>
          <div class="right">
            <img src="../assets/imgs/图片/船海平台/05.png" alt="" />
          </div>
        </div>
      </div>
      <div
        class="cla1 wow slideInUp topWidth fiveMian"
        data-wow-delay="0.3s"
      >
        <h4>{{ $t('business.2-1') }} - {{ $t('business.2-6') }}</h4>
        <div>
          <div class="left">
            <img src="../assets/imgs/图片/船海平台/06.png" alt="" />
          </div>
          <div class="right">
            <h5>{{ $t('business.2-20') }}</h5>
            <p>
              {{ $t('business.2-21') }}
            </p>
            <h5>{{ $t('business.2-15') }}</h5>
            <p>
              {{ $t('business.2-22') }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="cla1 wow slideInUp topWidth sixMian"
        data-wow-delay="0.3s"
      >
        <div>
          <div class="left">
            <h4>{{ $t('business.2-1') }} - {{ $t('business.2-7') }}</h4>
            <h5 style="text-align: center">{{ $t('business.2-23') }}</h5>
            <p>
              {{ $t('business.2-24') }}
            </p>
          </div>
          <div class="right">
            <img src="../assets/imgs/图片/船海平台/07.png" alt="" />
          </div>
        </div>
      </div>
      <div
        class="cla1 wow slideInUp topWidth sevenMian"
        data-wow-delay="0.3s"
      >
        <h4>{{ $t('business.2-1') }} - {{ $t('business.2-8') }}</h4>
        <div>
          <div class="left">
            <img src="../assets/imgs/图片/船海平台/08.png" alt="" />
          </div>
          <div class="right">
            <ul>
              <li>{{ $t('business.2-25') }}</li>
              <li>{{ $t('business.2-26') }}</li>
              <li>{{ $t('business.2-27') }}</li>
              <li>{{ $t('business.2-28') }}</li>
              <li>{{ $t('business.2-29') }}</li>
              <li>{{ $t('business.2-30') }}</li>
              <li>{{ $t('business.2-31') }}</li>
              <li>{{ $t('business.2-32') }}</li>
              <li>{{ $t('business.2-33') }}</li>
              <li>{{ $t('business.2-34') }}</li>
              <li>{{ $t('business.2-35') }}</li>
              <li>{{ $t('business.2-36') }}</li>
              <li>{{ $t('business.2-37') }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-show="num == 2">
      <div class="box3 wow slideInUp" data-wow-delay="0.3s">
        <h5>应急救援特装业务发展平台 - 业务架构</h5>
        <img src="../assets/imgs/集团业务/应急救援平台/01.png" alt="" />
      </div>
      <div class="box3 wow slideInUp" data-wow-delay="0.3s">
        <div class="one">
          <div>
            <h5>应急救援特装业务发展平台</h5>
            <h6>泰州市金海运船用设备有限责任公司</h6>
            <p>
              天海防务的全资子公司，作为天海防务应急救援特种装备研发制造基地，主要从事高新技术领域产品（高速船艇、应急救援装备、特种装备等）的研制与生产，为客户提供优良装备和服务保障。
            </p>
            <h6>资质</h6>
            <p>
              获得专利授权179项。7项产品被认定为“江苏省高新技术产品”，1项产品入选“国家火炬计划”。3项产品通过“江苏省首台套重大装备及关键零部件”认定，是三泰地区有实力的应急救援特种装备供应商
            </p>
          </div>
          <div>
            <img src="../assets/imgs/图片/应急救援/01.png" alt="" />
          </div>
        </div>
      </div>
      <div class="box3 wow slideInUp" data-wow-delay="0.3s">
        <h5>应急救援特装业务发展平台 - 金海运主要产品</h5>
        <ul>
          <li>国家高新技术企业</li>
          <li>江苏省工程技术中心</li>
          <li>ISO9001质量管理体系认证</li>
          <li>ISO24001环境管理体系认证</li>
          <li>ISO28001职业健康安全管理体系认证</li>
          <li>中国潜水大佬行业协会会员单位</li>
          <li>国际海上人命救助联盟团体会员单位</li>
        </ul>
        <img src="../assets/imgs/集团业务/应急救援平台/05.png" alt="" />
      </div>
      <div class="box3 wow slideInUp" data-wow-delay="0.3s">
        <div class="two">
          <h5>应急救援特装业务发展平台 - 主要业绩</h5>
          <ul>
            <li>高速突击快艇</li>
            <li>执法巡逻艇</li>
            <li>8000HP-AHTS</li>
            <li>海上边检巡逻艇</li>
            <li>侦查冲锋舟</li>
            <li>12000吨综合补给船</li>
            <li>海上输送过驳系统</li>
            <li>上海港新型引航母船</li>
            <li>20000吨级半潜船</li>
          </ul>
          <img src="../assets/imgs/图片/应急救援/02.png" alt="" />
        </div>
      </div>
      <div class="box3 wow slideInUp" data-wow-delay="0.3s">
        <div>
          <h5>应急救援特装业务发展平台 - "一带一路"业务探索</h5>
          <div class="three">
            <img src="../assets/imgs/图片/应急救援/03.png" alt="" />
            <div>
              <h6>巴基斯坦测量船</h6>
              <p>
                公司响应国家号召，积极在“一带一路”上进行业务拓展。承接了巴基斯坦测量船总承包项目，该项目由上海佳豪船海工程设计院设计，江苏大津重工负责总装建造。本船具备先进的地形勘探、水文监测等功能，为巴基斯坦的当前投资建造的吨位最大、最先进的测量船。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="num == 3">
      <div
        class="energy wow slideInUp topWidth"
      >
        <h4>应急救援特装业务发展平台 - 业务架构</h4>
        <img src="../assets/imgs/集团业务/新能源平台/01.png" alt="" />
      </div>
      <div style="width: 1200px; margin: 80px auto" class="box3 wow slideInUp nineMain">
        <div class="energyone">
          <div>
            <h4>新能源综合利用与服务平台 - 上海沃金天然气利用有限公司</h4>
            <h6>上海沃金天然气利用有限公司</h6>
            <p>
              上海拥有天然气运营资质的供应商之一，致力与构建以天然气为主的新能源的采购、仓储、分销、物流和加注等增值服务的产业链。充分把握水运行业绿色转型带来的发展机遇，积极构建和发展LNG陆路、水路的天然气供应网络。积极发挥天海防务在能源领域的行业领先作用。
            </p>
          </div>
          <div>
            <img src="../assets/imgs/图片/新能源/01.png" alt="" />
          </div>
        </div>
      </div>
      <div class="energyBox wow slideInUp tenMain">
        <h4>新能源综合利用与服务平台 - 水陆联动LNG船设计</h4>
        <img src="../assets/imgs/图片/新能源/03.png" alt="" />
      </div>
      <div class="energyBox wow slideInUp lastMain">
        <h4>新能源综合利用与服务平台 - 水陆联动LNG船设计</h4>
        <p style="text-align: center">
          <img src="../assets/imgs/图片/新能源/02.png" alt="" />
        </p>
        <div class="title">
          <p class="p1">国内首个LNG动力示范船队</p>
          <p class="p2">沃金LNG加气站</p>
        </div>
        <p class="lastP">
          坚持开拓“绿色发展”道路，响应国家“气化长江”和“发展绿色航运”的号召，天海防务依托于总部资源于2014年启动了全国首批LNG动力内河货船示范项目的设计和建造工作。在新能源的推广和利用上不断创新突破，率先打造国内首个LNG动力示范船队。
        </p>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
// import Swiper from './components/swiper.vue'
import { WOW } from 'wowjs'
export default {
  data() {
    return {
      // 轮播图
      slide: [],
      num: 1
    }
  },
  components: {
    // Swiper
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      const wow = new WOW({
        live: false
      })
      wow.init()
    })
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.containers {
  box-sizing: border-box;
  min-width: 1200px;
  padding-top: 120px;
  background-color: #112945;
  // background: linear-gradient(to right, #6495ED 0%,#112945  20%, #112945  50%,#112945  85%, #6495ED 100%);
  padding-bottom: 250px;
  font-family: 'Times New Roman', Georgia, Serif;
  @media screen and (max-width: 1200px) {
    padding-top: 150px;
  }

  /deep/.today .cell {
    color: #333 !important;
    font-weight: 500 !important;
  }

  // 轮播
  .swiper {
    width: 100%;
    height: calc(100vh - 60px);
    background-color: #fff;
    // @media screen and (max-width: 1600px) {
    //   height: 700px;
    // }
    // @media screen and (max-width: 1400px) {
    //   height: 600px;
    // }
    // @media screen and (max-width: 475px) {
    //   width: 100%;
    //   height: 200px;
    // }
    .el-carousel {
      height: 100%;
      /deep/.el-carousel__container {
        height: 100%;
      }
    }
    // .swiper-slide {
    //   width: 100%;
    //   font-size: 50px;
    //   text-align: center;
    // }
    // .swiper-pagination {
    //   .swiper-pagination-bullet {
    //     width: 30px;
    //     height: 2px;
    //     cursor: pointer;
    //     background-color: #fff;
    //     border-radius: 0;
    //   }
    // }
  }
  // 选择
  .choice {
    width: 1200px;
    margin: 20px auto;
    background-color: #112945;
    ul {
      display: flex;
      justify-content: space-between;
      img {
        @media screen and (max-width: 1200px) {
          margin-bottom: 20px;
        }
      }
      @media screen and (max-width: 1200px) {
        flex-flow: wrap;
        justify-content: center;
        margin-bottom: 20px;
      }
    }
  }
  .box {
    width: 1200px;
    margin: 20px auto;
    display: flex;
    justify-content: space-between;
    img {
      width: 30%;
    }
  }
  .cla1 {
    color: #fff;
    margin: 30px 0;
    h4 {
      font-size: 26px;
      color: #fff;
      margin: 20px 0;
      font-weight: 700;
    }
    h5 {
      font-size: 22px;
      font-weight: 700;
    }
    p {
      font-size: 18px;
      line-height: 22px;
      margin-top: 15px;
    }
    > div {
      display: flex;
    }
    .left {
      margin-right: 30px;
      @media screen and (max-width: 1200px) {
        width: 1000px;
      }
      p {
        font-size: 22px;
        line-height: 28px;
      }
    }
    .right {
      font-size: 22px;
      line-height: 28px;
      color: #fff;
      text-indent: 1em;
      @media screen and (max-width: 1200px) {
        width: 800px;
      }
      h5 {
        margin-top: 20px;
      }
      li {
        font-size: 22px;
        line-height: 34px;
        list-style: initial;
        text-indent: 0em;
        margin-left: 10px;
      }
    }
  }
  .box1 {
    // background-color: #112945;
    // background: linear-gradient(to right, #6495ED 0%,#112945  20%, #112945  50%,#112945  85%, #6495ED 100%);
    padding: 10px 0;
    margin: 40px 0;
    text-align: center;
    p {
      text-align: left;
      color: #fff;
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 30px;
      font-weight: 700;
      font-size: 26px;
    }
    img {
      width: 1200px;
    }
  }
  .box2 {
    background-image: url(../assets/imgs/产品与业务/船海平台/8.png);
    background-repeat: no-repeat;
    background-size: 100%;
    padding: 10px 0;
    text-align: center;
    img {
      width: 1200px;
    }
  }
  .box3 {
    padding: 10px 0;
    width: 1200px;
    margin: 0 auto;
    margin-top: 80px;
    h5 {
      color: #fff;
      font-size: 26px;
      margin-bottom: 40px;
      text-align: center;
    }
    img {
      width: 1200px;
    }
    .one {
      display: flex;
      color: #fff;
      h4 {
        font-size: 30px;
        text-align: center;
        line-height: 40px;
        margin-top: 15px;
      }
      h5 {
        font-size: 30px;
        text-align: left;
        font-family: 'Times New Roman', Georgia, Serif;
      }
      h6 {
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        margin: 30px 0;
        font-family: 'Times New Roman', Georgia, Serif;
      }
      p {
        font-size: 24px;
        font-family: 'Times New Roman', Georgia, Serif;
        text-indent: 2em;
      }
      img {
        width: 507px;
        margin-left: 60px;
      }
    }
    .two {
      ul {
        li {
          width: 200px;
          margin-right: 40px;
        }
      }
    }
    .three {
      display: flex;
      > div {
        margin-left: 50px;
      }
      h6 {
        color: #fff;
        font-size: 24px;
        font-weight: 700;
      }
      p {
        color: #fff;
        font-size: 22px;
        text-indent: 2em;
        margin-top: 20px;
        line-height: 28px;
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 40px;
      li {
        margin-right: 55px;
        list-style-type: disc;
        color: #fff;
        font-size: 22px;
      }
    }
  }
  .energy {
    color: #fff;
    @media screen and (max-width: 1200px) {
      width: 80%!important;
      margin: 0 0 0 200px!important;
    }
    h4 {
      font-size: 30px;
      color: rgb(255, 255, 255);
      margin: 30px 0;
      font-weight: 700;
    }
    img {
      @media screen and (max-width: 1200px) {
        width: 100%;
      }
    }
  }
  .energyone {
    display: flex;
    color: #fff;
    img {
      width: 507px;
      margin-left: 60px;
    }
    h4 {
      font-size: 30px;
      text-align: center;
      line-height: 40px;
      margin-top: 15px;
    }
    h5 {
      font-size: 30px;
      text-align: left;
      font-family: 'Times New Roman', Georgia, Serif;
    }
    h6 {
      font-size: 24px;
      font-weight: 700;
      text-align: center;
      margin: 30px 0;
      font-family: 'Times New Roman', Georgia, Serif;
    }
    p {
      font-size: 24px;
      text-indent: 2em;
      line-height: 26px;
    }
  }
  .energyBox {
    color: #fff;
    width: 1200px;
    margin: 80px auto;
    h4 {
      font-size: 30px;
      text-align: center;
      line-height: 40px;
      margin-top: 15px;
      font-weight: 700;
    }
    > P {
      font-size: 22px;
      text-indent: 2em;
      margin-top: 35px;
    }
    .title {
      display: flex;
      // justify-content: space-around;
      .p1 {
        width: 670px;
        text-align: center;
        font-size: 26px;
      }
      .p2 {
        width: 300px;
        text-align: center;
        font-size: 26px;
      }
    }
  }
    .topWidth {
      width: 1200px;
      margin: 40px auto;
      @media screen and (max-width: 1200px) {
        margin: 40px 0;
      }
    }
    .oneMain {
      @media screen and (max-width: 1200px) {
        margin-left: 200px;
        .left {
          width: 850px;
        }
        .right {
          width: 600px;
        }
      }
    }
    .twoMain {
      @media screen and (max-width: 1200px) {
        margin-left: 200px;
        .left {
          width: 850px;
        }
        .right {
          width: 600px;
        }
      }
    }
    .threeMain {
      box-sizing: border-box;
       @media screen and (max-width: 1200px) {
        width: 100%!important;
        padding-left: 200px!important;
        .left {
          width: 900px;
        }
        .right {
          width: 600px;
        }
      }
    }
    .fourMian {
      @media screen and (max-width: 1200px) {
        box-sizing: border-box;
        width: 100%!important;
        padding-left: 200px!important;
        .left {
          width: 600px;
        }
        .right {
          width: 900px;
        }
      }
    }
    .fiveMian {
       @media screen and (max-width: 1200px) {
        box-sizing: border-box;
        width: 100%!important;
        padding-left: 200px!important;
        .left {
          width: 1000px;
        }
        .right {
          width: 500px;
        }
      }
    }
    .sixMian {
      @media screen and (max-width: 1200px) {
        box-sizing: border-box;
        width: 100%!important;
        padding-left: 200px!important;
        .left {
          width: 600px;
        }
        .right {
          width: 500px;
        }
      }
    }
    .sevenMian {
      @media screen and (max-width: 1200px) {
        box-sizing: border-box;
        width: 100%!important;
        padding-left: 200px!important;
        .left {
          width: 1100px;
        }
        .right {
          width: 500px;
        }
      }
    }
    .nineMain {
      @media screen and (max-width: 1200px) {
        box-sizing: border-box;
        width: 100%!important;
        padding-left: 200px!important;
        .energyone {
          div {
            width: 1000px;
          }
        }
        .right {
          width: 500px;
        }
      }
    }
    .tenMain {
      @media screen and (max-width: 1200px) {
        box-sizing: border-box;
        width: 100%!important;
        padding-left: 200px!important;
        img {
          width: 90%;
        }
      }
    }
    .lastMain {
      @media screen and (max-width: 1200px) {
        box-sizing: border-box;
        width: 100%!important;
        padding-left: 100px!important;
        img {
          width: 90%;
        }
        .lastP {
          width: 90%;
          padding-left: 100px;
        }
      }
    }
}
</style>
